/*
* @Author: Mark Miller
* @Date:   2018-08-29 23:18:31
* @Last Modified by:   msmiller
* @Last Modified time: 2019-12-15 14:29:23
*
* Copyright (c) 2017-2018 Sharp Stone Codewerks / Mark S. Miller
*/


import { Controller } from "stimulus"

export default class extends Controller {

  connect() {
    // console.log("-=> pinger_controller connected");
    this.load()

    if (this.data.has("refreshInterval")) {
      this.startRefreshing()
    }
  }

  disconnect() {
    this.stopRefreshing();
  }

  load() {
    fetch(this.data.get("url"))
      .then(response => response.text())
      .then(html => {
        this.element.innerHTML = html

        if (html > 0) {
          $('#unread_messages_badge').show();
        } else {
          $('#unread_messages_badge').hide();
        }
      })
  }

  startRefreshing() {
    this.pingerTimer = setInterval(() => {
      this.load()
    }, this.data.get("refreshInterval"))
  }

  stopRefreshing() {
      if (this.pingerTimer) {
        clearInterval(this.pingerTimer)
      }
    }

  };

  // console.log("-=> pinger_controller loaded");


